import sendRequest from "../fetch";
import api from "../url";
import Qs from "qs";
import { cleanParams } from "@/utils";
import downloadFile from "../download";
import { localTime } from "@/utils/utils.js";

const _base = "jwExam/";

// 在线考试 - 列表
export const onlineExaminationPage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "myPage", {
    data: _params,
    method: "GET",
  });
};

// 在线考试 - 详情
export const onlineExaminationView = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "view", {
    data: _params,
    method: "GET",
  });
};
// 在线考试 - 考试题目
export const onlineExaminationAssign = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + `assign/${params.examId}`, {
          //  data: _params,
           method: "GET",
         });
       };

// 在线考试 - 保存答题
export const onlineExaminationSave = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "save", {
           data: _params,
           method: "POST",
         });
       };
// 在线考试 - 提交试卷（单独设置超时 15 秒；超时/报错时给出错误提示）
export const onlineExaminationSubmit = (params) => {
         let _params = cleanParams(params);
         return sendRequest(api.url + _base + "submit", {
           data: _params,
           method: "POST",
           timeout: 15000,
           showError: true,
           errorMsg: "交卷超时或失败，请检查网络后重试",
         });
       };

// 在线考试 - 进入考试前检查
export const examCheck = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "check", {
    data: _params,
    method: "GET",
  });
};

// 在线考试 - 学生答题记录列表
export const onlineExaminationStudentRecordList = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "studentRecordList", {
    data: _params,
    method: "GET",
  });
};

// 在线考试 - 查看学生答题详情
export const onlineExaminationViewRecord = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "viewRecord", {
    data: _params,
    method: "GET",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/onlineExamination.js